module.exports = __webpack_public_path__ + "static/media/chocie-and-control-image.72235740.svg";